import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import axios from "axios"; import Cookies from "js-cookie";
import moment from "moment";

import HelpComponent from "../HelpComponent";
import _FM_FolioListComponent from "../_FM_folio/_FM_FolioListComponent";

const _FM_CustomerShowComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id,action} = useParams();
  const [formData, setFormData] = useState({});
  const [CFormData, setCFormData] = useState({});
  const [CFields, setCFields] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.customerId || window.App.urlVars().customerId || id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "customer/" + (props.customerId ?? window.App.urlVars().customerId ?? id),
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [])

  // useEffect(() => {
  //   if (formData._country_specifics) {
  //     let countryObjectName = "customer_" + Object.keys(formData._country_specifics)[0].toLowerCase() + "s";
  //     axios({
  //       method: 'get',
  //       url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "customer-"
  //         + Object.keys(formData._country_specifics)[0].toLowerCase() + "/" + formData[countryObjectName][0].id,
  //       params: {},
  //       headers: {
  //         'Authorization': 'Bearer ' + Cookies.get("userToken"),
  //         "Sys-name": Cookies.get("instanceId"),
  //         "Preferred-locale": Cookies.get("language")
  //       }
  //     })
  //       .then(response => {
  //         setCFormData(response.data.data);
  //         const transformedCountry = Object.keys(formData._country_specifics)[0]
  //           ? Object.keys(formData._country_specifics)[0].charAt(0).toUpperCase() + Object.keys(formData._country_specifics)[0].slice(1).toLowerCase() : "";
  //         axios({
  //           method: 'get',
  //           url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "info/Customer" + transformedCountry,
  //           params: {},
  //           headers: {
  //             'Authorization': 'Bearer ' + Cookies.get("userToken"),
  //             "Sys-name": Cookies.get("instanceId"),
  //             "Preferred-locale": Cookies.get("language")
  //           }
  //         })
  //           .then(response => {
  //             setCFields(response.data.editable_fields);
  //           })
  //           .catch(error => {
  //             window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //           })
  //       })
  //       .catch(error => {
  //         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //       })
  //   }
  // }, [formData._country_specifics])

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
        {formData.firstname && formData.lastname ? (
          <>{formData.lastname + ' ' + formData.firstname}</>
        ):(
          <>{t('customer_show')}</>
        )}
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          {window.location.href.includes('#/customer') &&
            <Button type="button" aria-label={t('edit')}
                    icon={"pi pi-pencil"}
                    onClick={() => {
                      navigate('/customer/')
                      setTimeout(() => {
                        navigate('/customer/update/' + id)
                      },500)
                    }}
                    className="p-button-warning p-ml-2">
            </Button>
          }
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    navigate(-1)
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('created_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
      </div>
      <Panel className={"p-mt-3"}>
        {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
        <HelpComponent type={"show_box"}/>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="gender">{t("gender")}</label>
              <span className="p-d-block p-text-bold">{t(formData.gender?.toLowerCase())}</span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="birth_date">{t("birth_date")}</label>
              <span className="p-d-block p-text-bold">
                {moment.utc(formData.birth_date).local().format(t('YYYY-MM-DD'))}
              </span>
            </div>
          </div>
          {/* Birth Place */}
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="birth_place">{t("birth_place")}</label>
              <span className="p-d-block p-text-bold">
                {formData.birth_place}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="citizenship">{t("citizenship")}</label>
              <span className="p-d-block p-text-bold">
                {formData.citizenship}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="id_type">{t("id_type")}</label>
              <span className="p-d-block p-text-bold">
                {t(formData?.id_type?.toLowerCase())}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="id_number">{t("id_number")}</label>
              <span className="p-d-block p-text-bold">
                {formData.id_number}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="email">{t("email")}</label>
              <span className="p-d-block p-text-bold">{formData.email}</span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="phone">{t("phone")}</label>
              <span className="p-d-block p-text-bold">{formData.phone}</span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-2"}>
            <div className="p-field p-fluid">
              <label htmlFor="zip_code">{t("zip_code")}</label>
              <span className="p-d-block p-text-bold">
                {formData.zip_code}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="address">{t("address")}</label>
              <span className="p-d-block p-text-bold">
                {formData.address}
              </span>
            </div>
          </div>
          {/* Notes */}
          <div className={"p-col-12"}>
            <div className="p-field p-fluid">
              <label htmlFor="note">{t("note")}</label>
              <span className="p-d-block p-text-bold">{formData.note}</span>
            </div>
          </div>
        </div>
      </Panel>
      {id &&
      <Panel className={"p-mt-3"}>
        <_FM_FolioListComponent customerId={id} />
      </Panel>
      }
      {CFields && CFields[0] &&
        <>
          <Panel className={"p-mt-3"}>
            <h3 className={"p-mt-0"}>
              {Object.keys(formData._country_specifics)[0].toUpperCase()}
            </h3>
            <div className={"p-grid"}>
              {CFields.map((field, index) => {
                if (field.name && (typeof CFormData[field.name] === 'string' || typeof CFormData[field.name] === 'number')) {
                  return (
                    <div className={"p-col-12 p-lg-6"} key={index}>
                      <div className="p-field p-fluid">
                        <label htmlFor={field.name}>{t(field.name)}</label>
                        <span className="p-d-block p-text-bold">
                          {CFormData[field.name]}
                        </span>
                      </div>
                    </div>
                  )
                }
              })}
            </div>
          </Panel>
        </>
      }
    </>
  )
}
export default withTranslation('common')(_FM_CustomerShowComponent);
